var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"vf-steps"},_vm._l((_vm.list),function(m,i){return _c('li',{key:i,class:_vm.activeStep === i ? 'step activeStep' : _vm.activeStep === 1 ? 'step zIndexMax' : 'step'},[_vm._v(_vm._s(m))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }